import React from "react";

interface ValueDisplayProps {
	title: string;
	isBold?: boolean;
	value: any; // Using any to allow for any type of value
}

const ValueDisplay: React.FC<ValueDisplayProps> = ({ title, value, isBold = false }) => {
	return (
		<div>
			{isBold ? <b>{title}</b> : title}: {value !== null ? value : "Unknown"}
		</div>
	);
};

export default ValueDisplay;
